import { Site } from '.';
import { EvaluatedSiteProperties } from './evaluated-site-properties';

/* istanbul ignore file */
export class SitesLogicServiceModel {
    currentAppId = '';
    currentSite = new Site();
    exportingLayout = false;
    isSaving = false;
    isDirty = false;
    sitesLoading = false;
    siteLoading = false;
    sites = new Array<Site>();
    allSites = new Array<Site>();
    siteEvaluatedProperties = new Map<string, EvaluatedSiteProperties>();
    isNewSiteCreated = false;
}
